import { render, staticRenderFns } from "./PrintHeaderSSPSlim.vue?vue&type=template&id=51bbec66&scoped=true"
import script from "./PrintHeaderSSPSlim.vue?vue&type=script&lang=js"
export * from "./PrintHeaderSSPSlim.vue?vue&type=script&lang=js"
import style0 from "./PrintHeaderSSPSlim.vue?vue&type=style&index=0&id=51bbec66&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51bbec66",
  null
  
)

export default component.exports